import { Component, OnChanges, Input, inject, ChangeDetectionStrategy } from "@angular/core";

import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";
import { DvsChartComponent } from "src/app/shared/dvs-chart/dvs-chart.component";
import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-tach-detail",
	templateUrl: "./tach-detail.component.html",
	styleUrls: ["./tach-detail.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [DvsChartComponent]
})
export class TachDetailComponent implements OnChanges {
	private api = inject(ApiService);
	private charting = inject(ChartingService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	component: AssemblyConfig.Tach;
	@Input()
	raw: APIResults.RawSinglesResult;

	public tsoptions?: Highcharts.Options;
	public spectrumoptions?: Highcharts.Options;
	public errormessage: string;

	async ngOnChanges() {
		if (this.asset && this.component && this.raw) {
			this.tsoptions = undefined;
			this.spectrumoptions = undefined;
			this.errormessage = undefined;
			try {
				const result = await this.api.GetTachVibe(this.asset.asset_id, this.component.id, this.raw.rawid)
				this.tsoptions = this.charting.RevolutionDefaults("Time Sync Avg", result.tsastats, result.meanrpm, result.tsa, "RPM");
				this.spectrumoptions = this.charting.SpectrumDefaults("Spectrum", "Gs", [
					{ type: "line", name: "Spectrum", data: result.fft },
				], false);
			} catch (err) {
				this.errormessage = "Unable to load tach details";
				console.error("Couldn't load tach vibe");
				console.log(err);
			}
		}
	}
}
